// extracted by mini-css-extract-plugin
export default {"container":"InfoFormacoes_container__kJi4m","texto":"InfoFormacoes_texto__klUUX","icon":"InfoFormacoes_icon__rqitR"};